import LoadingCircle from "../components/LoadingCircle";

export default class AddPaymentMethod {

    constructor(profile) {

        this.profilePage=profile;
        this.stripe = Stripe(stripe_client_id);
        this.elements = this.stripe.elements();

        this.style = {
            base: {
              fontSize: '16px',
              color: '#32325d',
            },
        };
        this.cardElement = this.elements.create('card');
        this.cardElement.mount('#new-payment-method-card-element')
        this.cardHolderName = $('#card-holder-name');
        this.cardHolderNameError = $('#card-holder-name-error');
        this.cardError = $('#add-card-error');

        this.addPaymentMethodBtn = $('#add-payment-method-btn')

        this.events()
        this.onLoad()
    }

    events() {
        this.addPaymentMethodBtn.on('click', e => this.addPaymentMethod())
        this.cardHolderName.on('input paste change', e => this.cardHolderNameError.html(''))

        this.cardElement.on('focus',    (event) => this.cardError.text(''));
        this.cardElement.on('blur',     (event) => this.cardError.text(''));
        this.cardElement.on('escape',   (event) => this.cardError.text(''));
        this.cardElement.on('input',    (event) => this.cardError.text(''));
        this.cardElement.on('change',   (event) => this.cardError.text(''));

        this.cardHolderName.on('keypress', this.cardHolderKeyPressHandler)
        this.cardHolderName.on('paste', this.cardHolderPasteHandler)
    }

    cardHolderKeyPressHandler(event) {
        if(!event.key.match(/[a-zA-Z\s]/)) {
            event.preventDefault();
        }
    }
    cardHolderPasteHandler(event) {
        event.preventDefault()
    }

    onLoad() {

    }

    async addPaymentMethod() {
        let loadingCircle = new LoadingCircle()
        loadingCircle.buttonShow($('#add-payment-method-btn'))
        this.paymentMethod = await this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: {
                name: this.cardHolderName.val(),
            },
        }).then(res => res)

        console.log(this.paymentMethod)

        if(!this.cardHolderName.val().length) {
            this.cardHolderNameError.text('Card holder name is required.')
            loadingCircle.buttonHide($('#add-payment-method-btn'))
            this.cardHolderName.focus()
            return false;
        }

        if(this.paymentMethod.error) {
            this.cardError.html(this.paymentMethod.error.message)
        }

        if(this.paymentMethod.paymentMethod) {
            await axios.post(`/payment-method`, {
                paymentMethod: this.paymentMethod.paymentMethod.id
            }).then(res => {
                $('#addPaymentMethod').modal('hide')
                this.profilePage.getPaymentMethods();
                // $('#pills-payment table tbody').empty()
                // $('#pills-payment table tbody').append(
                //     `<tr>
                //         <td class="card-icon"><i class="fab fa-cc-${this.paymentMethod.paymentMethod.card.brand}"></i></td>
                //         <td>${this.paymentMethod.paymentMethod.card.funding}</td>
                //         <td>**** ${this.paymentMethod.paymentMethod.card.last4}</td>
                //         <td>${this.paymentMethod.paymentMethod.card.exp_year}/${this.paymentMethod.paymentMethod.card.exp_month}</td>
                //         <td>
                //         <a href="/payment-method/${this.paymentMethod.paymentMethod.id}/edit" class="text-bold">Update</a>
                //         </td>
                //     </tr>`
                // )
            }).catch(err => {
                console.log(err)
                if( err.response && err.response.data && err.response.data.message) {
                    this.cardError.html(err.response.data.message)
                }
            })
        }
        loadingCircle.buttonHide($('#add-payment-method-btn'))
    }
    
}
